module.exports = __webpack_public_path__ + "fonts/PlusJakartaSans-LightItalic.0b609f00.ttf";